import { combineReducers } from 'redux';
import darkMode from './darkmode';

const rootReducer = combineReducers({
  darkMode,
});

export default rootReducer;
